export default "__VITE_ASSET__R8mViWI8__"